import { render, staticRenderFns } from "./Grasa-Corporal.vue?vue&type=template&id=025c4e26&scoped=true&"
import script from "./Grasa-Corporal.vue?vue&type=script&lang=ts&"
export * from "./Grasa-Corporal.vue?vue&type=script&lang=ts&"
import style0 from "./Grasa-Corporal.vue?vue&type=style&index=0&id=025c4e26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025c4e26",
  null
  
)

export default component.exports